<!-- DESKTOP -->
<div class="show-desktop">
  <div class="container-overflow-auto-custom">
    <div class="overflow-auto-custom">

      <div class="d-flex p-16 header-table-advanceSales row">
        <div class="font-semiBold fts-12 col-2">Categorías</div>
        <div class="font-semiBold fts-12 col-2 d-flex justify-content-center">Plan</div>
        <div class="font-semiBold fts-12 col-1 d-flex justify-content-center">Real</div>
        <div class="font-semiBold fts-12 col-4 d-flex justify-content-center">Avance</div>
        <div class="font-semiBold fts-12 col-1 d-flex justify-content-end">Restante</div>
        <div class="col-2"></div>
      </div>

      <div class="container-expansion-panel mt-16">
        <ng-container *ngFor="let detail of itemsSkeletonDetail">
          <div class="container-border-line expansion-panel mb-16">
            <div class="d-flex align-items-center ph-16 row vw-100 height-custom">

              <div class="col-2">
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '16px', width: '100px', 'border-radius': '16px' }">
                </ngx-skeleton-loader>
              </div>

              <div class="col-2 d-flex justify-content-center">
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '16px', width: '70px', 'border-radius': '16px' }">
                </ngx-skeleton-loader>
              </div>

              <div class="col-1 d-flex justify-content-center">
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '16px', width: '52px', 'border-radius': '16px' }">
                </ngx-skeleton-loader>
              </div>

              <div class="col-4 d-flex justify-content-center align-items-center">
                <div class="vw-100 container-progress-line">
                  <ngx-skeleton-loader count="1" appearance="line"
                    [theme]="{ height: '8px', 'border-radius': '16px' }">
                  </ngx-skeleton-loader>
                </div>
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '16px', width: '40px', 'border-radius': '16px', 'margin-left': '8px' }">
                </ngx-skeleton-loader>
              </div>

              <div class="col-1 d-flex justify-content-end">
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '16px', width: '52px', 'border-radius': '16px' }">
                </ngx-skeleton-loader>
              </div>

              <div class="col-2 d-flex justify-content-end align-items-center">
                <ngx-skeleton-loader count="1" appearance="line"
                  [theme]="{ height: '14px', width: '72px', 'border-radius': '16px' }">
                </ngx-skeleton-loader>
                <div class="icon-expand icon-expand-border">
                  <ngx-skeleton-loader count="1" appearance="line"
                    [theme]="{ height: '20px', width: '20px', 'border-radius': '4px' }">
                  </ngx-skeleton-loader>
                </div>
              </div>

            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</div>

<!-- MOBILE -->
<div class="show-mobile">
  <ng-container *ngFor="let detail of itemsSkeletonDetail">
    <div class="container-border-line vw-100 mb-24">
      <div class="p-24">

        <div class="d-flex justify-content-between align-items-center">
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '16px', width: '130px', 'border-radius': '16px' }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '24px', width: '24px', 'border-radius': '4px' }">
          </ngx-skeleton-loader>
        </div>

        <div class="mt-16">
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '14px', width: '90px', 'border-radius': '16px' }">
          </ngx-skeleton-loader>
        </div>

        <ngx-skeleton-loader count="1" appearance="line"
          [theme]="{ height: '8px', 'border-radius': '16px', 'margin-top': '8px', display: 'block' }">
        </ngx-skeleton-loader>

        <div class="d-flex justify-content-between mt-8">
          <div>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '12px', width: '36px', 'border-radius': '16px' }">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '14px', width: '60px', 'border-radius': '16px' }">
            </ngx-skeleton-loader>
          </div>
          <div class="text-right">
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '12px', width: '48px', 'border-radius': '16px' }">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '14px', width: '60px', 'border-radius': '16px' }">
            </ngx-skeleton-loader>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-12">
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '14px', width: '110px', 'border-radius': '16px' }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '14px', width: '90px', 'border-radius': '16px' }">
          </ngx-skeleton-loader>
        </div>

      </div>
    </div>
  </ng-container>
</div>
